/**
 * Extract a human-readable error message from an Axios error response.
 * Handles both { detail: string } and { detail: { detail: string } } backend formats.
 */
export function extractApiError(err: unknown, fallback = 'An unexpected error occurred'): string {
  const axiosErr = err as { response?: { data?: { detail?: string | { detail?: string } } } };
  const detail = axiosErr?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (typeof detail === 'object' && detail !== null && typeof detail.detail === 'string') return detail.detail;
  const genericErr = err as { message?: string };
  if (typeof genericErr?.message === 'string') return genericErr.message;
  return fallback;
}
